import { SOURCE } from 'constants/general';
import { HELP_CENTER_LINK } from 'constants/links';
import { HELP_CENTER_LOCALIZED_LANGUAGES } from 'constants/localization';

import { getLocalizationFromAvailable } from 'helpers/localization';

export const getHelpCenterLink = () => {
    const language = getLocalizationFromAvailable();

    if (HELP_CENTER_LOCALIZED_LANGUAGES.includes(language)) {
        return `${HELP_CENTER_LINK}/${language}/help-center`;
    }

    return `${HELP_CENTER_LINK}/help-center`;
};

export const generateContactUsLink = () => {
    const queryParams = new URLSearchParams({
        source: SOURCE,
        is_redirect: 'true', // this param is used to open chatbot on the help center page, if the user is redirected from the app
    });

    return `${getHelpCenterLink()}?${queryParams.toString()}`;
};
